import { forwardRef } from 'react'

import { Grid } from '@material-ui/core'
import { navbar } from 'Components/Validation/Settings/Users/Permisos'
import { Field, Formik } from 'formik'
import { TextField } from 'formik-material-ui'

const FormNew = forwardRef((props, ref) => {
  const { onSubmit } = props

  return (
    <>
      <Formik
        initialValues={{
          descripcion: '',
        }}
        validationSchema={navbar}
        onSubmit={onSubmit}
      >
        {({ submitForm, isSubmitting }) => (
          <Grid container spacing={2}>
            <Grid item sm={12} xs={12}>
              <div style={{ height: '70px' }}>
                <Field
                  component={TextField}
                  fullWidth
                  label="Nombre Navbar"
                  name="descripcion"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    maxLength: 50,
                  }}
                />
              </div>
            </Grid>

            <button
              type="submit"
              onClick={submitForm}
              disabled={isSubmitting}
              ref={ref}
              style={{ display: 'none' }}
            />
          </Grid>
        )}
      </Formik>
    </>
  )
})
export default FormNew
